export const calculateMealsByDate = (details) => {
  return details.reduce((acc, meal) => {
    const date = String(meal.date).trim();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(meal);
    return acc;
  }, {});
};

export const calculateOrderedMeals = (orders) => {
  return orders.reduce((acc, meal) => {
    const date = String(meal.date).trim();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(meal);
    return acc;
  }, {});
};
